import { render, staticRenderFns } from "./CollapsibleSidebarLink.vue?vue&type=template&id=087cd9b3&scoped=true"
import script from "./CollapsibleSidebarLink.vue?vue&type=script&lang=js"
export * from "./CollapsibleSidebarLink.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleSidebarLink.vue?vue&type=style&index=0&id=087cd9b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087cd9b3",
  null
  
)

export default component.exports